/** Stable id shared with VaulDrawer titleId to avoid duplicate sr-only Drawer.Title focus stop (iOS ViewBreakup_B02). */
export const TAX_LIABILITY_BREAKUP_HEADING_ID = 'tax-liability-breakup-heading'
